export default function PullQuote({ blok }) {
  const hasContent = blok.quote && blok.quote !== ""

  return hasContent ? (
    <div className="bg-grey-cool-tint px-3 py-4 shadow-[4px_4px_4px_0px_rgba(0,0,0,0.20)] my-8">
      <h3 className="text-primary">{blok.heading}</h3>
      <div className="px-6 relative min-h-[112px] before:content-[''] before:bg-[url('public/assets/curly-bracket.svg')] before:bg-[length:26px_100%] before:bg-no-repeat before:absolute before:w-[26px] before:h-28 before:-left-2 sm:before:-left-3 before:top-0 content-[''] after:bg-[url('public/assets/curly-bracket.svg')] after:bg-[length:26px_100%] after:bg-no-repeat after:absolute after:rotate-180 after:w-[26px] after:h-28 after:bottom-0 after:-right-2 sm:after:-right-3 transition-all duration-300">
        <blockquote className="py-2">{blok.quote}</blockquote>
        <cite className="not-italic block pt-2">{blok.citation}</cite>
      </div>
    </div>
  ) : null
}
